import { useBrandingAssets } from "@/hooks/useBrandingAssets";

interface HeroSectionProps {
  countdownDate?: string;
}

export function HeroSection({ countdownDate }: HeroSectionProps) {
  const { faviconUrl } = useBrandingAssets();
  return (
    <>
      {/* Logo */}
      <div className="mb-8">
        <div className="flex items-center justify-center mb-4">
          <img
            src={faviconUrl}
            alt="PayStreem Logo"
            className="w-16 h-16 mr-3"
          />
        </div>
        <p className="text-white/80 text-lg">
          The future of music streaming is coming
        </p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-semibold text-white mb-3">
          Something Amazing is Coming
        </h2>
        <p className="text-white/70 leading-relaxed">
          Be the first to experience the revolutionary music platform that
          connects artists, fans, and sponsors in unprecedented ways.
        </p>
      </div>
    </>
  );
}
